import { z } from "zod";

export const CONNECTED_USERS_DESCRIPTION =
  "View and manage connected users across all environments";

export const CONNECTED_USERS_PAGE_SIZES = [25, 50, 100] as const;

const DEFAULT_PAGE_SIZE = 25;

export const connectedUsersSearchSchema = z.object({
  userId: z.string().catch("").default(""),
  providerId: z.string().catch("").default(""),
  limit: z
    .number()
    .int()
    .min(1)
    .max(CONNECTED_USERS_PAGE_SIZES.at(-1) ?? 100)
    .catch(DEFAULT_PAGE_SIZE)
    .default(DEFAULT_PAGE_SIZE),
  offset: z.number().int().min(0).catch(0).default(0),
});

export type ConnectedUsersSearch = z.infer<typeof connectedUsersSearchSchema>;

export const connectedUsersSearchDefaults: ConnectedUsersSearch = {
  userId: "",
  providerId: "",
  limit: DEFAULT_PAGE_SIZE,
  offset: 0,
};

/** The subset of the search state that narrows the result set. */
export type ConnectedUsersFilters = Omit<
  ConnectedUsersSearch,
  "limit" | "offset"
>;

export const pickFilters = ({
  userId,
  providerId,
}: ConnectedUsersSearch): ConnectedUsersFilters => ({ userId, providerId });

export const connectedUsersFilterDefaults: ConnectedUsersFilters = {
  userId: "",
  providerId: "",
};
